import axios from "axios";

const namespaced = true; // Make sure the module is namespaced
// const token = window.localStorage.getItem("token");
const state = {
  users: {},
  username: "",
};
const getters = {
  GetUser: state => state.users,
};
const actions = {
  async fetchUser({ commit }) {
    let response = await axios.get('user')
    commit('setUserData', response.data.data)
  },
  async createUser({commit}, user){
    await axios.post('initialize',user).then(response =>{
      console.log(response.data);
      commit('setUserProfile', response.data)
      // alert(response.data.message );
    }).catch(err =>{
      console.log(err);
    });
  },
  async checkUsername({ commit },user){
    await axios.post('check-user',user).then(response =>{
      console.log(response.data.message);
      commit('setUsername', response.data.message);
      // alert(response.data.message );
    }).catch(err =>{
      console.log(err);
      commit('setUsername', response.data.message)
    });
    // console.log(response.data.message);
    // alert(response.data.message );

  },
  async resendOtp({ commit }, payload) {
    let response = await axios.post('card/otp-resend', payload)
    commit('setUserData', response.data.data)
  },
  async verifyOtp({ commit }, payload) {
    let response = await axios.post('emailverify', payload)
    commit('setUserData', response.data.data)
  },
};
const mutations = {
    setUserData(state, userData) {
        state.users = userData;
      },
      setUserProfile(state, userData) {
        state.users = userData;
      },
      setUsername(state, userData) {
        state.username = userData;
      }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
